import Repository from "./repository";
import store from "@/store/index.js";

export default {
  show(segment, preview, token) {
    const lang = store.state.language;
    if (preview == "preview" && token) {
      return Repository.get(`/preview/freepages/${segment}/show`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          hl: lang,
        },
      });
    } else {
      return Repository.get(`/freepages/${segment}/show`, {
        params: {
          hl: lang,
        },
      });
    }
  },
};
